import React from 'react'
import {connect} from 'react-redux'
import {changeOptionValue, changeGlobalSetting} from '../actions'
import {StyledOption, OptionText, OptionInput, OptionSelect} from "../styled-components/option-styling"

function getDropdownOptions(options){
    var optionArray = [];
    options.map((key, value) => optionArray[parseInt(key)] = <option key={key} value={key}>{value}</option>);
    return optionArray;
}

function onChange(props, e){
    if(props.optionType === "action"){
        props.dispatch(changeOptionValue(props.preset, props.buttonID, props.actionID, props.optionName, props.option.get('data-slot'), e.target.value));
    } else if (props.optionType === "global"){
        props.dispatch(changeGlobalSetting(props.optionName, e.target.value))
    }
    return null
}

const Option = (props) => {
    if(!props.option.get("isHidden")) {
        return (
            <StyledOption>

                <OptionText>{props.optionName}:</OptionText>

                {
                    props.option.get('range').get('type') === "number" &&
                    <OptionInput type="number" value={props.option.get('value')} onChange={(e)=>onChange(props, e)}
                                 max={props.option.get('range').get('max')}
                                 min={props.option.get('range').get('min')}></OptionInput>
                }

                {
                    props.option.get('range').get('type') === "note" &&

                    <OptionInput type="text" value={props.option.get('value')} onChange={(e)=>onChange(props, e)}
                                 placeholder={props.option.get('placeholder')}
                                 maxLength={props.option.get('range').get('max')}></OptionInput>
                }

                {
                    props.option.get('range').get('type') === "dropdown" &&

                    <OptionSelect value={props.option.get('value')} onChange={(e)=>onChange(props, e)}>
                        {getDropdownOptions(props.option.get('range').get('options'))}
                    </OptionSelect>
                }

            </StyledOption>
        )
    } else{
       return ("")
    }

}

const getCurrentOption = (actions,preset, buttonID, actionID, optionName) =>{
    return actions.present.get(preset).get(buttonID).get(actionID).get('options').get(optionName)
}

function mapStateToProps(state, props){
    if(props.optionType === "action"){
        return{
            option : getCurrentOption(state.buttonActions, state.preset, props.buttonID, props.actionID, props.optionName)
        }
    } else if(props.optionType === "global"){
        return{
            option : props.option
        }
    } else{
        return {}
    }
}

export default connect(mapStateToProps)(Option)

